import { CSSObject } from '@chakra-ui/react';
import background from '../../../assets/vikingbet/images/backgrounds/backgroundNotAllowLocation.png';
import backgroundAtRetina from '../../../assets/vikingbet/images/backgrounds/backgroundNotAllowLocationMB.png';

export const LocationNotAllowedContainer: CSSObject = {
  h: undefined,
  justifyContent: [null, null, 'center'],
  minH: '100vh',
  bgImage: `url(${background})`,
  bgRepeat: 'no-repeat',
  bgSize: ['100%', '100%'],
  lineHeight: '4',

  '@media (-webkit-min-device-pixel-ratio: 2)': {
    bgImage: `url(${backgroundAtRetina})`,
  },
};

export const CenterWrapper: CSSObject = {
  bg: 'transparent',
  borderRadius: [null, null, 'xl'],
  color: 'white',
  flex: ['1', null, '0'],
  gap: '0',
  justifyContent: 'center',
  mt: ['0', null, '12'],
  mb: [null, null, '12'],
  minH: [null, null, '668px'],
  maxW: 'container.md',
  px: ['4', null, '28'],
  py: ['3', null, '8'],
  textShadow: '0 4px 10px rgba(0, 0, 0, .2)',
};

export const ContentHeadingText: CSSObject = {
  fontFamily: 'SkranjiBold',
  fontSize: ['5xl', null, '6xl'],
  lineHeight: ['2.6rem', null, '3.6rem'],
  mt: ['1.5', null, '4'],
  mb: ['2.5', null, '4'],
  filter: 'drop-shadow(0px 5px 5px rgba(0,0,0,.5))',
  bg: 'linear-gradient(180deg, #FCD236 0%, #E79004 100%)',
  backgroundClip: 'text',
  fontWeight: '700',
  textTransform: 'uppercase',
  WebkitTextFillColor: 'transparent',
  WebkitBackgroundClip: 'text',
};

export const ContentBodyText: CSSObject = {
  fontSize: ['md', 'lg'],
  fontWeight: 'semibold',
  mb: '3',
  lineHeight: 'tall',
  textAlign: 'center',

  b: {
    display: 'block',
    fontSize: 'md',
    lineHeight: 'base',
    mb: '4',
  },

  '.chakra-link': {
    fontSize: ['2xs', 'xs'],
    fontWeight: 'bold',
  },
};

export const ContactText: CSSObject = {
  '&&': {
    fontSize: ['sm', null, 'lg'],
  },
};

export const TextBodyCopy: CSSObject = {
  lineHeight: '5',
  fontSize: ['sm', null, 'lg'],
  mt: '4',
};

export const TextHeadingColor: CSSObject = {
  bgGradient: 'linear(to-b, alpha.500, gamma.500)',
  bgClip: 'text',
  textShadow: 'none',
  display: 'flex',
};

export const RegistrationContent: CSSObject = {
  fontSize: ['xs', null],
  w: [null, null, '591px'],
  '.chakra-link': {
    fontSize: ['xs', null],
    fontWeight: 'bold',
  },
};

export const ContentBodyNT: CSSObject = {
  fontSize: ['xs', null, 'md'],
  mb: '4',
  textAlign: 'center',
  fontWeight: 'normal',
  lineHeight: '5',
  '.chakra-link': {
    fontWeight: 'bold',
    color: 'white',
    fontSize: ['xs', null, 'md'],
    textDecoration: 'none',
  },
  div: {
    fontSize: ['xs', null, 'sm'],
  },
};